import { render } from "./svoyClubInfoPopup.vue?vue&type=template&id=a1284d34&scoped=true"
import script from "./svoyClubInfoPopup.vue?vue&type=script&lang=js"
export * from "./svoyClubInfoPopup.vue?vue&type=script&lang=js"

import "./svoyClubInfoPopup.vue?vue&type=style&index=0&id=a1284d34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1284d34"]])

export default __exports__